import { render } from "./TTitle.vue?vue&type=template&id=32f37eea&scoped=true"
import script from "./TTitle.vue?vue&type=script&lang=js"
export * from "./TTitle.vue?vue&type=script&lang=js"

import "./TTitle.vue?vue&type=style&index=0&id=32f37eea&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f37eea"]])

export default __exports__